// Utilities
import { mapState } from 'vuex';
import { themeColors, themesMixin, vuetifyColors } from '@/utils/themes';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreFilter',
  mixins: [themesMixin],
  props: {
    userT: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    var _this$userT, _this$userT2;
    const userDefaults = ((_this$userT = this.userT) === null || _this$userT === void 0 || (_this$userT = _this$userT.properties) === null || _this$userT === void 0 ? void 0 : _this$userT.userDefaults) || {
      color: 'niotix',
      language: 'de',
      mapLayout: '',
      uiTheme: false,
      drawer: true,
      miniVariant: false,
      map3DBuild: false,
      pagination: 10
    };
    return {
      colors: themeColors,
      mapStyles: [{
        text: 'niotix',
        value: '1'
      }, {
        text: 'Satellite',
        value: '2'
      }, {
        text: 'Streets',
        value: '3'
      }, {
        text: 'Combo',
        value: '4'
      }],
      localUser: {
        ...(this.userT || {}),
        properties: {
          ...(((_this$userT2 = this.userT) === null || _this$userT2 === void 0 ? void 0 : _this$userT2.properties) || {}),
          userDefaults
        }
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'drawer', 'UiTheme', 'map3DBuild', 'language', 'themes', 'miniVariant', 'color', 'colorHexLight', 'colorHexDark']),
    lang() {
      return this.$store.state.app.language;
    },
    hasCustomColor() {
      return this.UiTheme ? this.colorHexDark : this.colorHexLight;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    userT: {
      deep: true,
      immediate: true,
      handler(user) {
        var _nextUser$properties;
        const nextUser = user || {};
        const nextDefaults = (nextUser === null || nextUser === void 0 || (_nextUser$properties = nextUser.properties) === null || _nextUser$properties === void 0 ? void 0 : _nextUser$properties.userDefaults) || {
          color: 'niotix',
          language: 'de',
          mapLayout: '',
          uiTheme: false,
          drawer: true,
          miniVariant: false,
          map3DBuild: false,
          pagination: 10
        };
        this.localUser = {
          ...nextUser,
          properties: {
            ...(nextUser.properties || {}),
            userDefaults: {
              ...nextDefaults
            }
          }
        };
      }
    },
    'localUser.properties.userDefaults': {
      deep: true,
      handler() {
        var _this$localUser;
        if ((_this$localUser = this.localUser) !== null && _this$localUser !== void 0 && (_this$localUser = _this$localUser.properties) !== null && _this$localUser !== void 0 && _this$localUser.userDefaults) {
          this.save();
        }
      }
    }
  },
  mounted() {
    var _this$$store, _this$userT3;
    const tenantID = (_this$$store = this.$store) === null || _this$$store === void 0 || (_this$$store = _this$$store.state) === null || _this$$store === void 0 || (_this$$store = _this$$store.authentication) === null || _this$$store === void 0 ? void 0 : _this$$store.tenantId;
    if (!((_this$userT3 = this.userT) !== null && _this$userT3 !== void 0 && (_this$userT3 = _this$userT3.properties) !== null && _this$userT3 !== void 0 && _this$userT3.userDefaults)) {
      ApiService.tenantGetById(tenantID, ['no-descendents']).then(tenant => {
        this.localUser.properties.userDefaults.color = tenant.data.theme.lightHighlightCustomer ? 'customerColor' : tenant.data.theme.lightHighlight;
      }).catch(e => {
        console.error(e);
      });
    }
  },
  methods: {
    resetDefaults() {
      var _this$$store2;
      const tenantID = (_this$$store2 = this.$store) === null || _this$$store2 === void 0 || (_this$$store2 = _this$$store2.state) === null || _this$$store2 === void 0 || (_this$$store2 = _this$$store2.authentication) === null || _this$$store2 === void 0 ? void 0 : _this$$store2.tenantId;
      ApiService.tenantGetById(tenantID, ['no-descendents']).then(tenant => {
        this.localUser.properties.userDefaults = {
          color: tenant.data.theme.lightHighlightCustomer ? 'customerColor' : tenant.data.theme.lightHighlight,
          language: 'en',
          mapLayout: '',
          uiTheme: tenant.data.theme.mode === 'dark',
          drawer: true,
          miniVariant: false,
          map3DBuild: false,
          pagination: 10,
          customColor: tenant.data.theme.lightHighlightCustomer || tenant.data.theme.lightHighlight
        };
        this.$store.commit('app/setThingshiveColorLight', tenant.data.theme.lightHighlightCustomer || tenant.data.theme.lightHighlight);
        this.$store.commit('app/setThingshiveColorDark', tenant.data.theme.lightHighlightCustomer || tenant.data.theme.darkHighlight);
      }).catch(e => {
        console.error(e);
      });
    },
    save() {
      var _this$localUser2;
      if (!this.localUser || !this.localUser.id) {
        return;
      }
      const userDefaults = ((_this$localUser2 = this.localUser) === null || _this$localUser2 === void 0 || (_this$localUser2 = _this$localUser2.properties) === null || _this$localUser2 === void 0 ? void 0 : _this$localUser2.userDefaults) || {};
      ApiService.updateUserPartial({
        id: this.localUser.id,
        properties: {
          userDefaults
        }
      }).then(() => {
        this.setLang();
        this.setColor();
        this.$store.commit('app/setMapStyle', this.localUser.properties.userDefaults.mapLayout);
        const userCustomColor = this.localUser.properties.userDefaults.color === 'customerColor' ? this.localUser.properties.userDefaults.customColor : '';
        this.setUiTheme(userCustomColor);
        this.$store.commit('app/setDrawer', this.localUser.properties.userDefaults.drawer);
        this.$store.commit('app/setMiniVariant', this.localUser.properties.userDefaults.miniVariant);
        this.$store.commit('app/setMap3DBuild', this.localUser.properties.userDefaults.map3DBuild);
        this.$store.commit('app/setRowsPerPage', this.localUser.properties.userDefaults.pagination);
        this.$snack(this.$i18n_t('Common.userUpdated'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.userUpdatedFail'), 'error');
        }
      });
    },
    setColor(colorKey) {
      const mode = this.$store.state.app.UiTheme ? 'dark' : 'light';
      if (colorKey === 'customerColor') {
        this.$store.commit('app/setColor', mode === 'dark' ? 'customerColorDark' : 'customerColorLight');
      } else {
        this.$store.commit('app/setColor', this.localUser.properties.userDefaults.color);
        this.$store.commit('app/setThingshiveColorLight', this.$store.state.app.color);
        this.$store.commit('app/setThingshiveColorDark', this.$store.state.app.color);
      }
    },
    setLang() {
      this.$store.commit('app/language', {
        payload: this.localUser.properties.userDefaults.language,
        context: this
      });
    },
    setImage(image) {
      this.$store.commit('app/setImage', image);
      this.$store.commit('app/setThingshiveImage', this.$store.state.app.image);
    },
    isHexColor(color) {
      return /^#([0-9A-F]{3}){1,2}$/i.test(color);
    },
    setUiTheme(customColor) {
      const mode = this.localUser.properties.userDefaults.uiTheme ? 'dark' : 'light';
      if (customColor) {
        this.$store.commit('app/setColor', this.localUser.properties.userDefaults.color);
        this.$store.commit('app/setMode', mode);
        this.$store.commit('app/setUiTheme', mode === 'dark');
        this.$store.commit('app/setColorHexLight', customColor);
        this.$store.commit('app/setColorHexDark', customColor);
        const resolvedColor = this.isHexColor(customColor) ? customColor : vuetifyColors[customColor];
        this.$vuetify.theme.themes.light.primary = {
          base: resolvedColor
        };
        this.$vuetify.theme.themes.dark.primary = {
          base: resolvedColor
        };
        this.$store.commit('app/setThingshiveColorLight', this.$store.state.app.color);
        this.$store.commit('app/setThingshiveColorDark', this.$store.state.app.color);
        this.$store.commit('app/setThingshiveTheme', mode);
        this.$vuetify.theme.dark = mode === 'dark';
      } else {
        const userHighlight = mode === 'dark' ? this.$store.state.app.thingshiveColorDark : this.$store.state.app.thingshiveColorLight;
        this.$store.commit('app/setThingshiveTheme', mode);
        this.$store.commit('app/setColor', userHighlight || this.themes[mode].highlight);
        this.$store.commit('app/setMode', mode);
        this.$store.commit('app/setUiTheme', mode === 'dark');
        const lightColor = this.$store.state.app.thingshiveColorLight;
        const fallbackLightColor = this.themes.light.highlight;
        const resolvedLightColor = this.isHexColor(lightColor) ? lightColor : vuetifyColors[lightColor] || fallbackLightColor;
        const darkColor = this.$store.state.app.thingshiveColorDark;
        const fallbackDarkColor = this.themes.dark.highlight;
        const resolvedDarkColor = this.isHexColor(darkColor) ? darkColor : vuetifyColors[darkColor] || fallbackDarkColor;
        this.$vuetify.theme.themes.light.primary = {
          base: resolvedLightColor
        };
        this.$vuetify.theme.themes.dark.primary = {
          base: resolvedDarkColor
        };
        this.$vuetify.theme.dark = this.localUser.properties.userDefaults.uiTheme;
      }
    },
    setMap3DBuild() {
      this.$store.commit('app/setThingshiveMap3DBuild', this.$store.state.app.map3DBuild ? '3D' : '2D');
    },
    setMiniVariant() {
      this.$store.commit('app/setMiniVariant', this.$store.state.app.miniVariant);
    },
    setLoader(a, b = false) {
      this.$store.state.app.load = a;
      this.$store.state.app.loading = b;
    },
    updateUserDefaults(key, value) {
      this.$set(this.localUser.properties.userDefaults, key, value);
    }
  }
};